/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */
import wrapContext from "./src/util/wrapContext"
export const wrapRootElement = wrapContext
